/* eslint-disable consistent-return */
import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';
import { map } from 'lodash';
import requiredIf from '../../modules/schema-conditional-required';

export const RPA_TYPES = {
  PLANE: 'Plane',
  MULTICOPTER: 'MultiCopter',
  properties: {
    PLANE: {
      name: 'PLANE',
      value: 'Plane',
      humanValue: 'Plane'
    },
    MULTICOPTER: {
      name: 'MULTICOPTER',
      value: 'MultiCopter',
      humanValue: 'MultiCopter'
    }
  }
};

const RPAs = new Mongo.Collection('RPAs');

RPAs.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

RPAs.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});

const flightParametersSchema = new SimpleSchema({
  maxDescendSlope: {
    type: SimpleSchema.Integer,
    label: 'The max slope for the descend of the rpas in %',
    min: 0,
    max: 200,
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('rpaType').value === RPA_TYPES.PLANE,
        schemaInstance: this
      });
    }
  },
  maxAscendSlope: {
    type: SimpleSchema.Integer,
    label: 'The max slope for the ascend of the rpas in %',
    min: 0,
    max: 200,
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('rpaType').value === RPA_TYPES.PLANE,
        schemaInstance: this
      });
    }
  },
  optimalLandingSlope: {
    type: SimpleSchema.Integer,
    label: 'The optimal slope for the landing the rpas in %',
    min: 0,
    max: 200,
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('rpaType').value === RPA_TYPES.PLANE,
        schemaInstance: this
      });
    }
  },
  optimalTakeOffSlope: {
    type: SimpleSchema.Integer,
    label: 'The optimal slope for the takeoff of the rpas in %',
    min: 0,
    max: 200,
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('rpaType').value === RPA_TYPES.PLANE,
        schemaInstance: this
      });
    }
  },
  maxLandSpeed: {
    type: SimpleSchema.Integer,
    label: 'The max landing speed for the copter rpas in cm/s',
    min: 0,
    max: 200,
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('rpaType').value === RPA_TYPES.MULTICOPTER,
        schemaInstance: this
      });
    }
  },
  autonomy: {
    type: SimpleSchema.Integer,
    label: 'The max flight time for the rpas in minutes',
    min: 0
  }
});

const calibrationLogsSchema = new SimpleSchema({
  accelCalibrationLog: {
    type: Array,
    label:
      'An array representing the log got the accelerometers calibration, saving the date when calibration occurs'
  },
  'accelCalibrationLog.$': {
    type: String,
    label: 'An ISO String with the date of the calibration'
  },
  compassCalibrationLog: {
    type: Array,
    label:
      'An array representing the log got the compass calibration, saving the date when calibration occurs'
  },
  'compassCalibrationLog.$': {
    type: String,
    label: 'An ISO String with the date of the calibration'
  }
});

RPAs.schema = new SimpleSchema({
  owner: {
    type: String,
    label: 'The ID of the user this rpas belongs to.'
  },
  createdAt: {
    type: String,
    label: 'The date this rpas was created.',
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  updatedAt: {
    type: String,
    label: 'The date this rpas was last updated.',
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  },
  name: {
    type: String,
    label: 'The name of the rpas.'
  },
  rpaType: {
    type: String,
    label: 'The type of the rpas.',
    allowedValues: map(RPA_TYPES.properties, 'value')
  },
  model: {
    type: String,
    label: 'The model of the rpas.',
    optional: true
  },
  registrationNumber: {
    type: String,
    label: 'The registration number of this rpas.',
    optional: true
  },
  constructionDate: {
    type: String,
    label: 'The date this rpas was built.',
    optional: true
  },
  serialNumber: {
    type: String,
    label: 'The serial number of this rpas.',
    optional: true
  },
  weight: {
    type: Number,
    label: 'The weight of this rpas in grams.',
    min: 0,
    optional: true
  },
  flightParameters: {
    type: flightParametersSchema,
    label: 'The parameters for the rpas flight.'
  },
  calibrationLogs: {
    type: calibrationLogsSchema,
    label: 'The log with the date of calibration',
    optional: true
  },
  deleted: {
    type: String,
    label: 'The date the rpas was deleted.',
    autoValue() {
      if (this.isInsert) return 'no';
    }
  }
});

RPAs.attachSchema(RPAs.schema);

export default RPAs;
